// extracted by mini-css-extract-plugin
module.exports = {"root":"F38RkPpa","title":"FTTPJQKT","companiesWrapper":"_1ic98ew"};